import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { timer } from 'rxjs';
import { ResearchAuthService } from '@core/authentication';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    public show = false;

    constructor(private router: Router, private auth: ResearchAuthService) {
        timer(2000).subscribe(() => {
            this.show = true;
        });
    }

    public login(): void {
        this.auth.login();
    }

    ngOnInit() {
        if (this.auth.userClaimsExist()) {
            this.router.navigate([this.auth.afterLoginRoute]);
        }
    }
}
